import {
  AspectRatio,
  Box,
  COLOR_PALETTE,
  OptimizeImage,
  Text,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

import { INFLEARN_URL } from '../../../../constants/urls';

type Props = {
  title: string;
  thumbnailUrl: string;
  id: number;
};

export default function RoadmapItem({ thumbnailUrl, title, id }: Props) {
  const { t } = useTranslation();

  return (
    <a href={INFLEARN_URL.ROADMAP_DETAIL(id)} aria-label={t('로드맵 상세 이동')}>
      <Box maw="100%">
        <AspectRatio
          bg="gray.2"
          ratio={3 / 1.57}
          css={{
            borderRadius: 8,
            overflow: 'hidden',
            border: `1px solid ${COLOR_PALETTE.gray[2]}`,
            img: {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            },
          }}
        >
          <OptimizeImage src={thumbnailUrl} w={260} alt={title} />
        </AspectRatio>
        <Text
          pt={10}
          px={4}
          weight={700}
          lineClamp={2}
          size="md"
          css={{
            wordBreak: 'break-all',
            [desktopFirstMediaQuery.mobile]: {
              fontSize: 14,
            },
          }}
        >
          {title}
        </Text>
      </Box>
    </a>
  );
}
